export default {
  primary: '#FF0018',
  secondary: '#222222',
  tertiary: '#222222',
  accent: '#FF6674',
  error: '#f55a4e',
  info: '#FF6674',
  success: '#5cb860',
  warning: '#ffa21a'
}
